import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function sessionReducer(state = initialState.session, action) {
  switch (action.type) {
    case types.LOAD_SESSION_SUCCESS: {
      let content = { ...state };
      content = action.session;
      content.loading = false;
      return content;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/sessionReducer.js